// a default place to put the map when we have no other input on where to put it (copy of existing function)
export const defaultCenter = {
	lat: 44.8599412,
	lng: -93.5953929
};

export const defaultZoom = 10;

export function mapConfig(googleMaps: google.maps.CoreLibrary): google.maps.MapOptions {
	return {
		mapId: '3c3c187d1dd3cb32',
		center: defaultCenter,
		zoom: defaultZoom,
		minZoom: 4,
		maxZoom: 18,
		mapTypeId: 'roadmap',
		clickableIcons: false,
		disableDoubleClickZoom: false,
		draggable: true,
		keyboardShortcuts: true,
		panControl: false,
		scrollwheel: false,
		mapTypeControlOptions: {
			position: googleMaps.ControlPosition.TOP_RIGHT
		},
		zoomControl: true,
		zoomControlOptions: {
			position: googleMaps.ControlPosition.RIGHT_TOP
		},
		streetViewControlOptions: {
			position: googleMaps.ControlPosition.RIGHT_TOP
		}
	};
}
